/** Date helpers shared by the admin release pages. */

/** ISO timestamp → yyyy-MM-dd for a <input type="date">. */
export function toDateInput(iso: string | null | undefined): string {
  return iso ? iso.substring(0, 10) : '';
}

/** yyyy-MM-dd → ISO timestamp (UTC midnight) or null. */
export function toIso(date: string): string | null {
  return date ? `${date}T00:00:00.000Z` : null;
}

/** "May 19 – May 30, 2026" style range; tolerant of missing ends. */
export function formatRange(
  startIso: string | null | undefined,
  endIso: string | null | undefined,
): string {
  const start = startIso ? new Date(startIso) : null;
  const end = endIso ? new Date(endIso) : null;
  const valid = (d: Date | null): d is Date => d != null && !Number.isNaN(d.getTime());

  if (!valid(start) && !valid(end)) return 'No dates set';

  const md = (d: Date) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const mdy = (d: Date) =>
    d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  if (valid(start) && valid(end)) {
    return start.getFullYear() === end.getFullYear()
      ? `${md(start)} – ${mdy(end)}`
      : `${mdy(start)} – ${mdy(end)}`;
  }
  return valid(start) ? `${mdy(start)} – …` : `… – ${mdy(end as Date)}`;
}
